@if (poolUnits() && poolUnits().length) {
  <div class="mt-d">
    <nz-form-item>
      <nz-form-label>{{ 'web.main.order.selectPoolUnit' | actrans }}</nz-form-label>
      <nz-form-control>
        <nz-select [ngModel]="selectedUnitId()" (ngModelChange)="select($event)">
          <nz-option [nzValue]="null" [nzLabel]="'----- ' + ('web.main.order.selectPoolUnit.empty' | actrans) + ' ----'"></nz-option>
          @for (u of poolUnits(); track u.unitId) {
            <nz-option
              [nzValue]="u.unitId"
              [nzLabel]="u.name + (u.amount != null ? ': kr ' + (u.amount | nf) : '')">
            </nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>
}
